import { ISelectItemProps } from 'native-base'
import { useCallback, memo } from 'react'

import { Select } from './atoms/Select'

import { useTranslation } from '~hooks'

type SelectListProps = {
  onChange: ({ label, value }: ISelectItemProps) => void
  itemsList?: ISelectItemProps[]
  selected?: string
}
export const SelectList = memo(({ selected = '', itemsList = [], onChange }: SelectListProps) => {
  const { t } = useTranslation()

  const onChangeHandler = useCallback(
    (value: string) => {
      const item = itemsList.find((el) => el.value === value)
      onChange({ label: item?.label || '', value })
    },
    [itemsList, onChange]
  )

  return (
    <Select
      mt={1}
      onValueChange={onChangeHandler}
      placeholder={t('offers_list_screen.select_location')}
      selectedValue={selected}
      size="md"
      values={itemsList}
    />
  )
})
